import Layout from '@/layout'

const route = {
  path: '/oceanNovelReport',
  component: Layout,
  redirect: '/oceanNovelReport/index',
  alwaysShow: true, // will always show the root menu
  name: 'releaseGroup',
  meta: {
    title: '巨量小说报表',
    icon: 'ONR',
    roles: [
      'ocean_novel_report'
    ]
  },
  children: [
    // 图表分析
    {
      path: '/oceanNovelReport/releaseGroupList/index',
      component: () => import('@/views/oceanNovelReport/releaseGroupList/index.vue'),
      name: 'releaseGroupList',
      meta: {
        title: '投放组列表',
        icon: 'component',
        roles: [
          'ocean_novel_report.release_group'
        ]
      }
    },
    {
      path: '/oceanNovelReport/operations/index',
      component: () => import('@/views/oceanNovelReport/operations/index.vue'),
      name: 'operations',
      meta: {
        title: '运营组列表',
        icon: 'component',
        roles: [
          'ocean_novel_report.operation_group'
        ]
      }
    },
    {
      path: '/oceanNovelReport/bookOwnership/index',
      component: () => import('@/views/oceanNovelReport/bookOwnership/index.vue'),
      name: 'bookOwnership',
      meta: {
        title: '书籍列表',
        icon: 'component',
        roles: [
          'ocean_novel_report.book'
        ]
      }
    },
    {
      path: '/oceanNovelReport/bindingRelationList/index',
      component: () => import('@/views/oceanNovelReport/bindingRelationList/index.vue'),
      name: 'bindingRelationList',
      meta: {
        title: '绑定关系列表',
        icon: 'component',
        roles: [
          'ocean_novel_report.bind'
        ]
      }
    }, {
      path: '/oceanNovelReport/reportList/index',
      component: () => import('@/views/oceanNovelReport/reportList/index.vue'),
      name: 'reportList',
      meta: {
        title: '报表列表',
        icon: 'component',
        roles: [
          'ocean_novel_report.bind_report'
        ]
      }
    }, {
      path: '/oceanNovelReport/totalReportList/index',
      component: () => import('@/views/oceanNovelReport/totalReportList/index.vue'),
      name: 'totalReportList',
      meta: {
        title: '总计报表',
        icon: 'component',
        roles: [
          'ocean_novel_report.bind_total_report'
        ]
      }
    },
    {
      path: '/bookwsummary/index',
      component: () => import('@/views/bookSummary/index.vue'),
      name: 'Bookwsummary',
      meta: {
        title: '书籍报表',
        icon: 'component',
        roles: [
          'ocean_novel_report.book_report'
        ]
      }
    },
    {
      path: '/oceanNovelReport/releaseReport/index',
      component: () => import('@/views/oceanNovelReport/releaseReport/index.vue'),
      name: 'releaseReport',
      meta: {
        title: '运营报表',
        icon: 'component',
        roles: [
          'ocean_novel_report.release_report'
        ]
      }
    }
    // , {
    //   path: '/oceanNovelReport/reportForm/index',
    //   component: () => import('@/views/oceanNovelReport/reportForm/index.vue'),
    //   name: 'reportForm',
    //   meta: {
    //     title: 'T图列表',
    //     icon: 'component',
    //     roles: [
    //       'release_report.bind_wechat_t_report'
    //     ]
    //   }
    // }
  ]
}

export default route
